
import { defineComponent } from 'vue'
import groupDetailMixin from '~/mixins/groupDetailMixin'
import { RouteNavigationParams } from '~/utils/router'

interface TabLink {
  icon: string
  label: string
  baseRouteName?: string
  route: RouteNavigationParams
}

export default defineComponent({
  name: 'GroupHeader',
  mixins: [groupDetailMixin],
  data() {
    return {
      loading: false,
      timerId: null as ReturnType<typeof setTimeout> | null
    }
  },
  created() {
    if (process.client) {
      this.timerId = setTimeout(() => {
        if (!this.group?.name) {
          this.loading = true
        }
      }, 300)
    }
  },
  async fetch(): Promise<void> {
    const { groupSlug } = this.$route.params
    if (!this.group?.name) {
      await this.fetchGroupInformation(groupSlug)
    }
    this.loading = false
  },
  beforeDestroy() {
    if (this.timerId) {
      clearTimeout(this.timerId)
      this.timerId = null
    }
  },
  computed: {
    navItems(): TabLink[] {
      return [
        {
          icon: 'gauge',
          label: 'Overview',
          route: {
            name: 'orgs-provider-owner-groups-groupSlug',
            params: this.$route.params
          }
        },
        {
          label: 'Repositories',
          icon: 'layers',
          route: {
            name: 'orgs-provider-owner-groups-groupSlug-repositories',
            params: this.$route.params
          }
        },
        {
          icon: 'pie-chart',
          label: 'Reports',
          baseRouteName: 'orgs-provider-owner-groups-groupSlug-reports',
          route: {
            name: 'orgs-provider-owner-groups-groupSlug-reports-owasp-top-10',
            params: this.$route.params
          }
        },
        {
          icon: 'settings',
          label: 'Settings',
          baseRouteName: 'orgs-provider-owner-groups-groupSlug-settings',
          route: {
            name: 'orgs-provider-owner-groups-groupSlug-settings-general',
            params: this.$route.params
          }
        }
      ]
    }
  },
  methods: {
    triggerExpand() {
      this.$root.$emit('ui:show-sidebar-menu')
    },
    activeLink(item: TabLink): boolean {
      return item.baseRouteName
        ? Boolean(this.$route.name?.startsWith(item.baseRouteName))
        : this.$route.name === item.route.name
    }
  },
  watch: {
    '$route.params': {
      handler(newParams, oldParams) {
        if (newParams.groupSlug !== oldParams.groupSlug) {
          this.fetchGroupInformation(newParams.groupSlug)
        }
      }
    }
  }
})
